import versionTableHeaders from "./versionTable";

export default {
  ...versionTableHeaders,
};
